/**
 * Created with IntelliJ IDEA.
 * User: shlomif
 * Date: 4/30/14
 * Time: 11:24 AM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var SoundStateModel = require("models/SoundStateModel");

    var SoundController = Marionette.Controller.extend({
        initialize: function() {
            this.model = new SoundStateModel();

            this.listenTo(this.model, "change", this._onModelChange);
        },
        toggleSound: function(state) {
            if(_.isUndefined(state)) {
                this.model.set("enabled", !this.model.get("enabled"));
            } else {
                this.model.set("enabled", state);
            }
        },
        isEnabled: function() {
            return this.model.get("enabled");
        },
        _onModelChange: function() {
            this.trigger(SoundController.TRIGGERING.CHANGE, this.model);
        }
    });

    SoundController.TRIGGERING = {
        CHANGE: "change"
    };

    return SoundController;
});